import React, { useState, useCallback, useRef, useEffect, useMemo } from "react";
import InputField from '../../Components/UI/InputField.tsx';
import Loader from "../UI/Loader.tsx";
import Dialog from '@mui/material/Dialog';
import { AppointmentDate, AppointmentTypes, ModalAppointmentCheckObj, ModalObj, typeAppointmentSartoria, AppointmentSartoria, AppointmentSartoriaOther } from "../../Models/Types.ts"
import IntlTelInput from 'intl-tel-input/react';
import { IntlTelInputRef } from "intl-tel-input/react";
import DialogTitle from '@mui/material/DialogTitle';
import { AppointmentRequestBase, AppointmentSartoriaRequest, RemoteAPI } from '../../appointmentApi.tsx';
import { parseDate } from "../../Utils/StringFunctions.ts";
import TileAppointmentCheck, { TileAppointmentCheckDataLocation } from "./Components/TileAppointmentCheck.tsx";
import Header from "../Header/Header.tsx";
import Footer from "../Footer/Footer.tsx";
import TileAppointmentCheckOthers from "./Components/TileAppointmentCheckOthers.tsx";

const emptyModalAppointmentObj = { show: false, customerQuantity: 0, selectedType: 0 }

export type TileSelectedAppointment = {
    id: string;
    data: AppointmentSartoria,
    appointment: AppointmentDate;
}

const CheckCode = () => {

    const [sendingData, setSendingData] = useState<boolean>(false)

    const [showModal, setShowModal] = useState<ModalObj>({ show: false, text: "" })

    const [country, setCountry] = useState<string>("")

    const [showAppointment, setShowAppointment] = useState<boolean>(false)

    const [instances, setInstances] = useState<typeAppointmentSartoria | null>(null)

    const [othersAppointment, setOthersAppointment] = useState<Array<AppointmentSartoria>>([])

    // const [selectedAppointmentDate, setSelectedAppointmentDate] = useState<AppointmentDate | null>(null)
    // const [selectedAppointmentDate, setSelectedAppointmentDate] = useState<Array<AppointmentDate>>([])
    // const [selectedAppointmentDate, setSelectedAppointmentDate] = useState<Map<string, AppointmentDate>>()
    const [selectedAppointmentDate, setSelectedAppointmentDate] = useState<Array<TileSelectedAppointment>>([])

    const [privacyChecked, setPrivacyChecked] = useState<boolean>(false)

    const inputRef = useRef<IntlTelInputRef>(null)

    const handleClose = useCallback(() => {
        if (showModal.text === "Richiesta inviata correttamemte.") {
            setShowModal({ show: false, text: "" })
            window.location.reload()
        }
        setShowModal({ show: false, text: "" })
    }, [])

    const onChangeCountry = useCallback((e: string) => {
        setCountry(e)
    }, [])

    const onGetAppointmentSartoria = useCallback(async () => {
        setSendingData(true)
        if (inputRef.current) {
            let request: AppointmentSartoriaRequest = { telephone: `+${inputRef.current.getInstance()?.getSelectedCountryData().dialCode}${inputRef.current?.getInput()?.value}` } as AppointmentSartoriaRequest;

            try {
                await RemoteAPI.getAppointmentSartoria(request).then(result => {
                    setInstances(result.data)
                    setOthersAppointment([result.data.others])
                });
                setShowAppointment(true)
                setSendingData(false)
                sessionStorage.setItem("telephone_number", `+${inputRef.current.getInstance()?.getSelectedCountryData().dialCode}${inputRef.current?.getInput()?.value}`)
                /* alert("Richiesta inviata correttamente.") */
            } catch (error) {
                setSendingData(false)
                console.log(error);
                setShowModal({ show: true, text: "Nessun riferimento trovato. Controlla che il numero inserito sia corretto." })
                //fare un alert
            }
        }

    }, [])

    console.log("instances", instances)

    const onSelectDate = useCallback((key: string, appointment: AppointmentDate | null, data: AppointmentSartoria) => {
        if (appointment !== null) {
            setSelectedAppointmentDate(old => {
                if (old.find(item => item.id === key)) {
                    return old.map(item => item.id === key ? ({ ...item, appointment: appointment }) : item)
                }
                return [...old, { id: key, appointment: appointment, data: data }]
            })
        }
        else {
            setSelectedAppointmentDate(old => old.filter(item => item.id !== key));
        }
    }, [selectedAppointmentDate])

    const phone = useMemo(() => {
        let telephone_number = sessionStorage.getItem("telephone_number")
        if (telephone_number === null) {
            telephone_number = ""
        }
        return telephone_number
    }, [selectedAppointmentDate])

    const onCreateAppointment = useCallback(async () => {

        if (!privacyChecked) {
            setShowModal({ show: true, text: "Accetta la privacy prima di continuare." })
            /*       alert("Privacy") */
            return;
        }
        setSendingData(true)
        try {
            const requestsQueue: Array<Promise<boolean>> = [];
            const sleep = (timeSleep: number) => {
                return new Promise(resolve => setTimeout(resolve, timeSleep))
            }
            let countResultSuccess = 0;
            let countResultError = 0;
            // selectedAppointmentDate.forEach(async (date) => {
            //     let notes: Array<string> = [];
            //     notes = date.data.items.map(item => `C.nr. ${item.nr_contratto} - ${item.appellativo} ${item.nome};`);

            //     const request: AppointmentRequestBase = {
            //         date: date.appointment.date,
            //         phone: phone,
            //         name: instances?.main_contact_info.name ? instances?.main_contact_info.name : "",
            //         surname: instances?.main_contact_info.surname ? instances?.main_contact_info.surname : "",
            //         times: date.appointment.slots[0],
            //         type: date.data.appointmentType,
            //         email: "",
            //         event_date: instances?.main_contact_info.event_date ? instances?.main_contact_info.event_date : "",
            //         customer_code: instances?.main_contact_info.customer_code ? instances?.main_contact_info.customer_code : "",
            //         locality: "",
            //         note: notes.join("\n"),
            //         manNumber: date.data.men,
            //         womanNumber: date.data.women,
            //         tailoringData: {
            //             mainId: instances?.main_contact_info.id ? instances?.main_contact_info.id : 0,
            //             confirmedIds: date.data.items.map(item => item.id)
            //         }
            //     };
            //     /*   requestsQueue.push(sleep(1000).then(() => {
            //           return RemoteAPI.createAppointment(request)
            //       })); */

            //     try {
            //         const result = await RemoteAPI.createAppointment(request)
            //         countResultSuccess++;
            //     } catch (error) {
            //         countResultError++;
            //     }
            //     await sleep(5000)
            // })

            for (let i = 0; i < selectedAppointmentDate.length; i++) {
                let date = selectedAppointmentDate[i];
                let notes: Array<string> = [];
                notes = date.data.items.map(item => `C.nr. ${item.nr_contratto} - ${item.appellativo} ${item.nome};`);

                const request: AppointmentRequestBase = {
                    date: date.appointment.date,
                    phone: phone,
                    name: instances?.main_contact_info.name ? instances?.main_contact_info.name : "",
                    surname: instances?.main_contact_info.surname ? instances?.main_contact_info.surname : "",
                    times: date.appointment.slots[0],
                    type: date.data.appointmentType,
                    email: "",
                    event_date: instances?.main_contact_info.event_date ? instances?.main_contact_info.event_date : "",
                    customer_code: instances?.main_contact_info.customer_code ? instances?.main_contact_info.customer_code : "",
                    locality: "",
                    note: notes.join("\n"),
                    manNumber: date.data.men,
                    womanNumber: date.data.women,
                    tailoringData: {
                        mainId: instances?.main_contact_info.id ? instances?.main_contact_info.id : 0,
                        confirmedIds: date.data.items.map(item => item.id)
                    }
                };
                
                try {
                    const result = await RemoteAPI.createAppointment(request)
                    countResultSuccess++;
                } catch (error) {
                    countResultError++;
                }
                if(selectedAppointmentDate.length > 1){
                    await sleep(5000);
                    console.log("ATTESA FINITA")
                }
                
            }


            if (countResultSuccess === selectedAppointmentDate.length) {
                setShowModal({ show: true, text: "Richiesta inviata correttamente." })
            } else {
                setShowModal({ show: true, text: "C'è stato qualche problema con la richiesta. Contattare l'assistenza" })
            }

            setSendingData(false)

            /* Promise.allSettled(requestsQueue)
                .then(requestResult => {
                    if (requestResult.filter(r => r.status === "rejected").length === requestResult.length) {
                        setSendingData(false)
                        setShowModal({ show: true, text: "C'è stato qualche problema con la richiesta. Contattare l'assistenza" })
                    } else {
                        setShowModal({ show: true, text: "Richiesta inviata correttamente." })
                        setSendingData(false)
                    }
                }) */
        } catch (error) {
            setSendingData(false)
            console.log(error);
            alert("Errore del Server. Contattare l'assistenza.")
        }

        //RemoteAPI.createAppointment();
    }, [selectedAppointmentDate, instances, privacyChecked])

    console.log(othersAppointment)

    return <>
        <Header />


        <div className="container-form-appointment">
            <form onSubmit={onGetAppointmentSartoria}>
                {!showAppointment && <div className="container-request-appointment">
                    <div className="label-font" style={{ textAlign: "center", fontSize: "30px" }}>
                        Inserisci numero di telefono per visualizzare i tuoi abiti
                    </div>
                    <div className={`row-input show-flex row-input-ritiri`}>
                        <IntlTelInput
                            onChangeCountry={onChangeCountry}
                            ref={inputRef}
                            initOptions={{
                                initialCountry: "it",
                                separateDialCode: true
                            }}
                        />
                    </div>
                    <div className={`container-button-appointment show-flex`}>

                        {sendingData ? <Loader /> : <button type="submit" id="button-request-appointment" className="button-request-appointment" onClick={onGetAppointmentSartoria}>
                            {"Conferma"}
                        </button>}
                    </div>
                </div>}
            </form>



            {showAppointment && instances !== null && <>

                <div className="container-request-appointment">
                    <div className="label-font" style={{ textAlign: "center", fontSize: "30px" }}>
                        Seleziona un appuntamento
                    </div>
                    * Sarebbe preferibile fissare l'appuntamento nei prossimi {instances.main_contact_info.max_days} giorni
                    {instances.brides.items.length > 0 && <TileAppointmentCheck key={"inst-brides"} id="inst-brides" dataAppointment={instances.brides} selectedAppointmentDate={selectedAppointmentDate.find(item => item.id === "inst-brides")?.appointment} setAppointmentDate={onSelectDate} othersAppointment={[instances.others]} appointmentDates={selectedAppointmentDate} />}
                    {othersAppointment.length > 0 && othersAppointment.map((o, index) => o.items.length > 0 ? <TileAppointmentCheckOthers key={`inst-additive-${index}`} id={`inst-additive-${index}`} dataAppointment={o} selectedAppointmentDate={selectedAppointmentDate.find(item => item.id === `inst-additive-${index}`)?.appointment} setAppointmentDate={onSelectDate} setOthersAppointment={setOthersAppointment} othersAppointment={othersAppointment} othersAppointmentIndex={index} /> : <></>)}
                    {/* {instances.others.items.length > 0 && <TileAppointmentCheck key={"inst-others"} id="inst-others" dataAppointment={instances.others} selectedAppointmentDate={selectedAppointmentDate.find(item => item.id === "inst-others")?.appointment} setAppointmentDate={onSelectDate} setOthersAppointment={setOthersAppointment} othersAppointment={othersAppointment.map<AppointmentSartoriaOther>(app => ({...app, location : "others"}))} setInstances={setInstances} location={TileAppointmentCheckDataLocation.INSTANCES} />} */}
                    {/* {othersAppointment.length > 0 && othersAppointment.map((o, index)=><TileAppointmentCheck key={`inst-additive-${index}`} id={`inst-additive-${index}`} dataAppointment={o} selectedAppointmentDate={selectedAppointmentDate.find(item => item.id === `inst-additive-${index}`)?.appointment} setAppointmentDate={onSelectDate} setOthersAppointment={setOthersAppointment} othersAppointment={[{...instances.others, location : "instances"}, ...othersAppointment.filter((app, i) => index !== i).map<AppointmentSartoriaOther>(app => ({...app, location : "others"})) ]} setInstances={setInstances} location={TileAppointmentCheckDataLocation.OTHER} othersAppointmentIndex={index} />)}    */}

                    <div className={`container-privacy-policy show-flex`}>
                        <div>
                            <input id="check-box-policy" type="checkbox" onChange={e => setPrivacyChecked(e.target.checked)} /> Dichiaro di aver letto e di accettare la
                            <a style={{ marginLeft: "5px" }} target="_blank"
                                href="https://www.iubenda.com/privacy-policy/33835044">Privacy Policy</a>
                        </div>
                    </div>

                    <div className={`container-button-appointment show-flex`}>
                        {sendingData ? <Loader /> : <button id="button-request-appointment" className="button-request-appointment" onClick={onCreateAppointment}> Richiedi
                            appuntamento
                        </button>}

                    </div>

                </div>
            </>
            }

        </div>
        <Dialog
            open={showModal.show}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <div style={{ padding: "20px" }}>
                {showModal.text}
            </div>
        </Dialog>
    </>
}

export default CheckCode